import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Formulario from 'components/public/Formulario/Formulario';
import { datosRegistroTaller } from 'utils/formData';
import { FechasRequest, HorarioDiaString, IFormulario, ISelectOptions } from 'utils/models/interfaces';
import { registroTaller } from 'services/servicioPost';
import { crearOpcionesTipos, obtenerFechasTaller } from 'utils/utilities';
import { anchoMaxLogueado, opcionesDias } from 'utils/constants';
import { useError } from 'services/ErrorContext';
import Spinner from 'components/public/Spinner/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSalas } from 'utils/redux/features/salasSlice';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import { AddCommentOutlined } from '@mui/icons-material';
import NoResponse from 'pages/auxiliares/NoResponse';
import DashboardContainer from 'components/PageContainer/DashboardContainer';
import NotAllowed from 'pages/auxiliares/NotAllowed';

interface IFormTaller {
  titulo: string;
  textoBoton: string;
}

const AltaTaller = ({ titulo, textoBoton }: IFormTaller) => {
  const [mensajeExito, setMensajeExito] = useState('');
  const { salas, loadingSalas, errorSalas } = useSelector((state: RootState) => state.salas);
  const { error, setError, clearError, loading, setLoading } = useError();
  const dispatch = useDispatch<AppDispatch>();
  const opcionesSalas: ISelectOptions[] = crearOpcionesTipos(salas, 'Sala');
  const error401 = errorSalas?.includes('permisos');

  useEffect(() => {
    dispatch(fetchSalas());
  }, [dispatch]);

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const diasFormulario: number[] = data.Dias; // Este es el array de números del formulario que corresponden a los días de la semana
    const idSala = data.Sala;
    const horarios = data.Horarios;

    const horariosString: HorarioDiaString[] = horarios.map((h, index) => {
      const dia = diasFormulario[index]; // Verificamos que haya un día disponible en el array Dias
      if (dia === undefined) {
        throw new Error('El número de días no coincide con el número de horarios.');
      }

      return {
        HoraIni: String(h.HorarioIni),
        HoraFin: String(h.HorarioFin),
        Dia: dia, // Asignamos el día del formulario
      };
    });

    const armadoFechas: FechasRequest = {
      FechaInicio: data.FechaInicio.toString(),
      FechaFin: data.FechaFin.toString(),
      Horarios: horariosString,
    };

    const fechasHorarios = obtenerFechasTaller(armadoFechas);
    const horariosJSON = JSON.stringify(fechasHorarios);

    // @ts-expect-error -- form field typed by react-hook-form, not in interface
    const afiche: IFile = data?.Afiche[0];

    const formData = new FormData();
    formData.append('Nombre', data.Nombre);
    formData.append('SalaId', String(idSala));
    formData.append('Docente', data.Docente);
    formData.append('Programa', data.Programa);
    formData.append('Afiche', afiche);
    formData.append('ValorCuota', String(data.ValorCuota));
    formData.append('VisibleEnGrilla', String(data.VisibleEnGrilla));
    formData.append('horariosJson', horariosJSON);
    formData.append('FechaInicio', armadoFechas.FechaInicio);
    formData.append('FechaFin', armadoFechas.FechaFin);
    formData.append('Horarios', '');

    const requestAltaTaller: FormData = formData;

    try {
      await registroTaller(requestAltaTaller, setError, setLoading, true);
      setMensajeExito('¡Taller registrado con éxito!');
    } catch (error) {
      console.error('Error de registro:', error);
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  return (
    <DashboardContainer>
      {loadingSalas ? (
        <Spinner />
      ) : errorSalas ? (
        error401 ? (
          <NotAllowed />
        ) : (
          <NoResponse />
        )
      ) : (
        <Box mx="auto" maxWidth={anchoMaxLogueado}>
          <Formulario
            campos={datosRegistroTaller}
            datos={opcionesDias.concat(opcionesSalas)}
            titulo={titulo}
            textoBoton={textoBoton}
            onSubmit={handleSubmit}
            onVolver={handleVolver}
            mensajeExito={mensajeExito}
            mensajeError={error}
            loading={loading}
            iconoBoton={AddCommentOutlined}
          />
        </Box>
      )}
    </DashboardContainer>
  );
};

export default AltaTaller;
